import { bridge } from '../../../bridge';

export const moveToHome = () => {
  bridge.openDeeplink('ably://home/today');
};
